// SupportAPI.js
import { ENV } from "../Utils"; // Ajusta la ruta de import de ENV según tu estructura

export class supportAPI {
  baseApi = ENV.BASE_API;

  /**
   * Obtener todos los tickets de soporte
   * GET /supporttickets/get
   */
  async getAllTickets(accessToken) {
    try {
      const url = `${this.baseApi}/supporttickets/get`;
      const params = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) {
        throw new Error(result.message || "Error al obtener los tickets");
      }

      return result; // { code, message, tickets: [...] }
    } catch (error) {
      console.error("Error en getAllTickets:", error);
      throw error;
    }
  }

  /**
   * Obtener todos los tickets de soporte de un usuario específico
   * GET /supporttickets/get/:userId
   * @param {string} userId - ID del usuario
   */
  async getTicketsByUser(accessToken, userId, { page = 1, limit = 10 } = {}) {
    try {
      const url = `${this.baseApi}/supporttickets/get/${userId}?page=${page}&limit=${limit}`;
      const params = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) {
        throw new Error(
          result.message || "Error al obtener los tickets del usuario",
        );
      }

      return result; // { code, message, tickets: {... paginate data...} }
    } catch (error) {
      console.error("Error en getTicketsByUser:", error);
      throw error;
    }
  }

  /**
   * Crear un nuevo ticket de soporte
   * POST /supporttickets/create
   * @param {Object} data - { title, description, clientInputId, clientOutputId, senderRole, message }
   */
  async createTicket(accessToken, data) {
    try {
      const url = `${this.baseApi}/supporttickets/create`;
      const params = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) {
        throw new Error(
          result.message || "Error al crear el ticket de soporte",
        );
      }

      return result; // { code, message, ticket: {...} }
    } catch (error) {
      console.error("Error en createTicket:", error);
      throw error;
    }
  }

  /**
   * Responder a un ticket existente
   * PATCH /supporttickets/response/:ticketId
   * @param {string} ticketId
   * @param {Object} data - { userId, senderRole, message }
   */
  async respondTicket(accessToken, ticketId, data) {
    try {
      const url = `${this.baseApi}/supporttickets/response/${ticketId}`;
      const params = {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) {
        throw new Error(result.message || "Error al responder el ticket");
      }
      return result; // { code, message, ticket: {...} }
    } catch (error) {
      console.error("Error en respondTicket:", error);
      throw error;
    }
  }

  /**
   * Cerrar un ticket de soporte
   * PATCH /supporttickets/close/:ticketId
   * @param {string} ticketId
   * @param {Object} data - { userId }
   */
  async closeTicket(accessToken, ticketId, data) {
    try {
      const url = `${this.baseApi}/supporttickets/close/${ticketId}`;
      const params = {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) {
        throw new Error(result.message || "Error al cerrar el ticket");
      }

      return result; // { code, message, ticket: {...} }
    } catch (error) {
      console.error("Error en closeTicket:", error);
      throw error;
    }
  }
}
